import { IActivityParams, IActivityResult } from '../activities';

export interface ICheckPreviousConditionParams extends IActivityParams {}

export interface ICheckPreviousConditionResult extends IActivityResult {
  value: boolean;
}
